import * as React from "react";
import { ICouncil } from "src/interfaces";
import CouncilHeaderWidget from "../../CouncilsHeader/CouncilHeaderWidget";

interface IProps {
  council: ICouncil;
  ordinal: number;
  operatingSurplusRatio?: number;
  financialLiabilites?: number;
  assetSustainability?: number;
  risk?: string;
}

const colors = {
  Higher: "negative-bg",
  Lower: "positive-bg",
  Moderate: "neutral-bg"
};

const RiskClassName = ( risk: string ) =>
`c-risk-card__footer ${
  colors[ risk ]
}`;

export default class RiskCard extends React.PureComponent<
IProps,
 {}> {
  public render() {
    return (
      <div className="c-risk-card">
        <div className="c-risk-card__header">

          <CouncilHeaderWidget
            ordinal={ this.props.ordinal }
            name={ this.props.council.name }
            feature={ false }
            councilId={ this.props.council.id }
          />
  
        </div>
        <div className="c-risk-card__body">
          <dl className="c-risk-card__list">
            <dt className="c-risk-card__heading">Revenue compared to spending</dt>
            <dd className="c-risk-card__summary">Operating surplus ratio % { ( this.props.operatingSurplusRatio ) ? ( 
                <span className={ ( this.props.operatingSurplusRatio > 0 && this.props.operatingSurplusRatio <= 10 ) ? 'c-risk-card__value positive' : 'c-risk-card__value' }>{ this.props.operatingSurplusRatio }%</span>
              ) : (
                <span className="c-risk-card__value unknown">Unavailable</span>
              ) }
            </dd>

            <dt className="c-risk-card__heading">Managing Debt</dt>
            <dd className="c-risk-card__summary">Net financial liabilities ratio % { ( this.props.financialLiabilites ) ? ( 
              <span className={ ( this.props.financialLiabilites <= 60 ) ? 'c-risk-card__value positive offset' : 'c-risk-card__value offset' }>{ this.props.financialLiabilites }%</span>
              ) : (
                <span className="c-risk-card__value unknown">Unavailable</span>
              )}
            </dd>

            <dt className="c-risk-card__heading">Renewing our infrastructure</dt>
            <dd className="c-risk-card__summary">Asset Sustainability Ratio % { ( this.props.assetSustainability ) ? ( 
              <span className={ ( this.props.assetSustainability > 90 ) ? 'c-risk-card__value positive' : 'c-risk-card__value' }>{ this.props.assetSustainability }%</span>
              ) : (
                <span className="c-risk-card__value unknown">Unavailable</span>
              )}
            </dd>
          </dl>
        </div>
        {( this.props.risk ) ? (
          <p className={ RiskClassName( this.props.risk ) }>
            <span className="c-risk-card__risk">{ this.props.risk } Risk</span>
          </p>
        ) : (
          <p className="c-risk-card__footer unknown-bg">
            <span className="c-risk-card__risk">Unknown Risk</span>
          </p>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/councilSustainability/RiskCard.tsx